import { render, staticRenderFns } from "./saas_list.vue?vue&type=template&id=245f4ba4&scoped=true"
import script from "./saas_list.vue?vue&type=script&lang=js"
export * from "./saas_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245f4ba4",
  null
  
)

export default component.exports